import ScrollMagic from 'scrollmagic';

const PinSidebarFilter = (
  options={},
  selector='[data-sidebar-filter]'
) => {
  const defaultOptions = {
    triggerHook: 0.1,
    triggerElement: `${selector} .sidebar`,
  }

  const sceneOptions = {
    ...defaultOptions,
    ...options,
  }

  const controller = new ScrollMagic.Controller();
  const mlq = window.matchMedia('(min-width: 768px)');

  if (mlq.matches) {
    const gridContainer = document.querySelector(`${selector} > .container`);
    const sidebarContainer = document.querySelector(`${selector} .sidebar-contain`);

    if (!gridContainer || !sidebarContainer) return;

    const gridHeight = gridContainer.offsetHeight;
    const sidebarHeight = sidebarContainer.offsetHeight;

    const sceneHeight = gridHeight - sidebarHeight;

    new ScrollMagic.Scene({
      ...sceneOptions,
      duration: sceneHeight,
    })
      .setPin('.sidebar-contain')
      .addTo(controller);
  }
}

export default PinSidebarFilter;